import { useDispatch, useSelector } from "react-redux";
import themeList from "../configs/themeList";
import getUITheme from "../configs/getUITheme";
import { updateFontFamily } from "../redux/actions";
import fontList from "../configs/fontList";
import { useTheme } from "../hooks/useTheme";
import { State } from "../props/State.props";

const ThemeChanger = () => {
  const getFontFamily = useSelector((state: State) => state.getFontFamily);
  const dispatch = useDispatch();
  const [, setTheme] = useTheme();
  const getTheme: string = useSelector((state: State) => state.getTheme);

  const titles: { [key: string]: string | undefined } = {
    dark: "Charcoal",
    light: "Vanilla",
  };

  return (
    <div
      className={`flex flex-col w-full h-auto bg-[#2a3035] text-dark-fg p-4 rounded-lg my-5`}
    >
      <span className="text-lg font-bold mb-2">Select Theme</span>
      <div
        className={`rounded-lg w-fit py-2 px-2 flex justify-between items-center gap-5`}
      >
        {themeList.map((item, index) => {
          const themeKey = index;
          return (
            <div
              key={themeKey}
              className={`flex justify-center items-center w-8 h-8 ${getUITheme(
                item
              ).bg()} rounded-full border-2 border-black cursor-pointer`}
              onClick={() => setTheme(item)}
              title={titles[item]}
            >
              {getTheme === item && (
                <i className={`fa fa-check ${getUITheme(item).fg()}`} />
              )}
            </div>
          );
        })}
      </div>
      <span className="text-lg font-bold mt-5 mb-2">Select Font</span>
      <div className="flex items-center flex-wrap">
        {fontList.map((font, index) => {
          const fontKey = index;
          return (
            <div
              key={fontKey}
              className={`p-2 m-1 w-auto font-medium border rounded-md ${
                getFontFamily !== font ? "border-slate-600" : "border-white"
              } cursor-pointer`}
              onClick={() => dispatch(updateFontFamily(font))}
            >
              {font}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ThemeChanger;
